import { safeDeleteSheet } from "@/lib/office-helpers";

const PROJECT6_SHEETS = ["Bonos de empleados", "Partes"] as const;

const EMPLOYEE_ROWS = [
  ["Sandra", 69270, 144330, 93110, 306710],
  ["Deon", 73790, 133590, 130220, 337600],
  ["George", 18740, 140760, 110500, 270000],
  ["Cindy", 85490, 133480, 101910, 320880],
  ["Frank", 130180, 67790, 110000, 307970],
  ["Brian", 87490, 49590, 37880, 174960],
  ["Adrian", 10300, 88000, 55000, 153300],
  ["Allen", 34596, 98754, 56789, 190139],
];

const PARTS_ROWS = [
  ["Sandra", 22338, 19369, 27563, 69270],
  ["Deon", 21112, 22555, 30123, 73790],
  ["George", 3015, 7200, 8525, 18740],
  ["Cindy", 4935, 30432, 50123, 85490],
  ["Frank", 37424, 60300, 32456, 130180],
  ["Brian", 16489, 35000, 36001, 87490],
  ["Adrian", 500, 2805, 6995, 10300],
  ["Allen", 19036, 10008, 5552, 34596],
];

export async function startProject16(): Promise<void> {
  await Excel.run(async (context) => {
    for (const sheetName of PROJECT6_SHEETS) {
      await safeDeleteSheet(context, sheetName);
    }

    const bonus = context.workbook.worksheets.add("Bonos de empleados");
    const parts = context.workbook.worksheets.add("Partes");

    bonus.getRange("A1:G1").merge();
    bonus.getRange("A1").values = [["Computer Sales and Support"]];
    bonus.getRange("A1").format.font.size = 30;
    bonus.getRange("A1").format.font.bold = true;
    bonus.getRange("A1").format.horizontalAlignment = "Left";

    bonus.getRange("C2:G2").merge();
    bonus.getRange("C2").values = [["Bonificaciones de Empleados"]];
    bonus.getRange("C2").format.font.size = 16;
    bonus.getRange("C2").format.font.bold = true;
    bonus.getRange("C2").format.horizontalAlignment = "Center";

    const bonusTable = bonus.tables.add("A3:G3", true);
    bonusTable.name = "BonosEmpleados";
    bonusTable.getHeaderRowRange().values = [[
      "Vendedores",
      "Partes",
      "Accesorios",
      "Servicios",
      "Venta total",
      "Comisión",
      "Compensación total",
    ]];
    bonusTable.rows.add(
      undefined,
      EMPLOYEE_ROWS.map(([name, partsValue, accessories, services, total]) => [
        name,
        partsValue,
        accessories,
        services,
        total,
        "",
        "",
      ]),
    );
    bonusTable.style = "TableStyleMedium9";

    bonus.getRange("F4").formulas = [["=B15*E4"]];
    bonus.getRange("G4").formulas = [["=SUM(F4:F4)"]];
    bonus.getRange("A14:B14").merge();
    bonus.getRange("A14").values = [["Tarifas"]];
    bonus.getRange("A14").format.font.bold = true;
    bonus.getRange("A15").values = [["Porcentaje de comisión"]];
    bonus.getRange("B15").values = [[0.04]];
    bonus.getRange("B15").numberFormat = [["0%"]];
    bonus.getRange("A15:B15").format.borders.getItem("EdgeTop").style = "Continuous";
    bonus.getRange("A15:B15").format.borders.getItem("EdgeBottom").style = "Continuous";
    bonus.getRange("A15:A15").format.borders.getItem("EdgeLeft").style = "Continuous";
    bonus.getRange("B15:B15").format.borders.getItem("EdgeRight").style = "Continuous";
    bonus.getRange("A15").format.font.bold = true;

    bonus.getRange("A:A").format.columnWidth = 110;
    bonus.getRange("B:G").format.columnWidth = 105;
    bonus.getRange("B4:E11").numberFormat = Array(8).fill([
      "$#,##0",
      "$#,##0",
      "$#,##0",
      "$#,##0",
    ]);
    bonus.getRange("F4:F11").numberFormat = Array(8).fill(["$#,##0.00"]);
    bonus.getRange("G4:G11").numberFormat = Array(8).fill(["$#,##0"]);

    parts.getRange("A1:F1").merge();
    parts.getRange("A1").values = [["Ventas y Soporte Técnico"]];
    parts.getRange("A1").format.font.size = 28;
    parts.getRange("A1").format.font.bold = true;
    parts.getRange("A1").format.horizontalAlignment = "Left";

    const partsTable = parts.tables.add("A3:F3", true);
    partsTable.name = "VentasPartes";
    partsTable.getHeaderRowRange().values = [[
      "Vendedor",
      "Enero",
      "Febrero",
      "Marzo",
      "Total",
      "Tendencia",
    ]];
    partsTable.rows.add(
      undefined,
      PARTS_ROWS.map(([name, january, february, march, total]) => [
        name,
        january,
        february,
        march,
        total,
        "",
      ]),
    );
    partsTable.style = "TableStyleMedium9";

    // Placeholder in F4 — sparkline insertion will clear it
    parts.getRange("F4").values = [["(Minigráfico)"]];
    parts.getRange("F4").format.font.color = "#999999";
    parts.getRange("F4").format.font.italic = true;

    parts.getRange("A:A").format.columnWidth = 110;
    parts.getRange("B:F").format.columnWidth = 90;
    parts.getRange("B4:E11").numberFormat = Array(8).fill([
      "$#,##0",
      "$#,##0",
      "$#,##0",
      "$#,##0",
    ]);

    bonus.activate();
    bonus.getRange("A1").select();

    await context.sync();
  });
}
